import type { NonIndexRouteObject } from "react-router-dom";

import UpdateForkRoute from "./UpdateForkRoute";

export const updateForkRoute: NonIndexRouteObject = {
  element: <UpdateForkRoute />,
};
